import type MP4Box from 'mp4box';
import type { AddError } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';
import { hasAudio } from '../hasAudio';

const validateUploadFileHasAudio = (info: MP4Box.Mp4BoxInfo, addError: AddError): void => {
  if (!hasAudio(info)) {
    addError(VALIDATIONS.NO_AUDIO);
  }
};

export default validateUploadFileHasAudio;
